import { render, staticRenderFns } from "./SubsidiariesTable.vue?vue&type=template&id=c0778002&scoped=true&"
import script from "./SubsidiariesTable.vue?vue&type=script&lang=js&"
export * from "./SubsidiariesTable.vue?vue&type=script&lang=js&"
import style0 from "./SubsidiariesTable.vue?vue&type=style&index=0&id=c0778002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0778002",
  null
  
)

export default component.exports